import { S3_FOLDER_URL } from "Config";
import { TEMPLATE_TYPES } from "../constants";
import { formatDateFromTo, formatTime } from "./utils";

export const isEmpty = (value) => {
  if (Array.isArray(value) || typeof value === "string") {
    return value.length === 0;
  }
  if (typeof value === "object" && value !== null) {
    return Object.keys(value).length === 0;
  }
  return !value;
};
export function isUrl(str) {
  const regexp =
    /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;

  return regexp.test(str);
}

export const trimUrlSlashes = (url) => url.replace(/^\/+|\/+$/g, "");

export const prepareS3ResourceUrl = (
  baseS3Url,
  urlPath,
  appendEventsFolder = true,
) => {
  if (isUrl(urlPath ?? "")) return urlPath;
  if (isEmpty(baseS3Url) || isEmpty(urlPath) || !baseS3Url || !urlPath)
    return "";

  const base = trimUrlSlashes(baseS3Url);
  const path = trimUrlSlashes(urlPath).replace("eventsFolder", "events-folder");
  const pathPrefix =
    appendEventsFolder && path.split("/")[0] !== "events-folder"
      ? "events-folder"
      : "";

  return `${base}${isEmpty(pathPrefix) ? "/" : `/${pathPrefix}/`}${path}`;
};

export const formatWakeUp = (wakeUp) => {
  let {
    id,
    nameFr,
    isVirtual,
    startDateTime,
    endDateTime,
    memberPrice,
    nonMemberPrice,
    languages,
  } = wakeUp;
  const getBannerImageUrl = (wakeUp) => {
    const imageUrl = wakeUp.urlBannerFr || wakeUp.pictureUrlFr;
    return prepareS3ResourceUrl(S3_FOLDER_URL, imageUrl);
  };

  const bannerImgUrl = getBannerImageUrl(wakeUp);
  let mode = "";

  let location = isVirtual ? "En live" : "Sur place";
  let speakerEventName = "";
  let speakerPhoto = "";

  let speakers = wakeUp["speakers-abstract"]?.speakers || [];

  if (speakers.length > 0) {
    let firstSpeaker = speakers[0];
    speakerEventName =
      `${firstSpeaker.firstName || ""} ${firstSpeaker.lastName || ""}`.trim();

    speakerPhoto = firstSpeaker.pictureUrl ? firstSpeaker.pictureUrl : "";
  }

  let eventUrl =
    wakeUp.urlBadgeFr && wakeUp.urlBadgeFr.startsWith("http")
      ? wakeUp.urlBadgeFr
      : "";

  let wakeupPlace = wakeUp.placeFr || "";
  let wakeupReplay =
    wakeUp.isReplayable === 1 ? "comprend l'option: replay" : wakeupPlace;

  const defaultLogos = {
    9: "https://s3.tamtam.pro/local/storage/media/IMAGE/2174/AVATAR_54cbd68e1ba9284a1e486bd5d8551259cd51d96e.png",
    1256: "https://s3.tamtam.pro/local/storage/media/IMAGE/6348/AVATAR_e4fb37d14607091b2d1057ac4aa3b56c60e12f77.png",
  };

  let fiduciaireLogo = "";

  if (wakeUp.type === "formation") {
    fiduciaireLogo = wakeUp.clientData?.avatarUrl || "";
  } else {
    fiduciaireLogo = defaultLogos[wakeUp.client] || "";
  }

  let formattedEventDate = formatDateFromTo(startDateTime, endDateTime);

  let formattedStartTime = formatTime(startDateTime);

  let formattedEndTime = formatTime(endDateTime);

  const parsedLanguages = JSON.parse(languages);
  const languageKey = Object.keys(parsedLanguages)[0].toLowerCase();

  function getSpeakerImageBlock(speakerPhoto) {
    if (!speakerPhoto) {
      return null;
    }

    return `
      <img
        src="${speakerPhoto}"
        alt="Speaker"
        width="26"
        height="26"
        style="border-radius: 50%; display: inline-block; background-color: #ffffff; vertical-align: middle;"
      >
  `;
  }
  const formattedBlockImg = getSpeakerImageBlock(speakerPhoto);
  return {
    id,
    type: TEMPLATE_TYPES["WAKEUP_LAYOUT"],
    nameFr: nameFr || "",
    mode,
    speakerEventName,
    speakerPhoto: formattedBlockImg,
    location,
    eventDate: formattedEventDate,
    startTime: formattedStartTime,
    endTime: formattedEndTime,
    wakeUpPrice:
      nonMemberPrice !== undefined && nonMemberPrice !== null
        ? `${nonMemberPrice}`
        : "0",
    wakeupMemberPrice:
      memberPrice !== undefined && memberPrice !== null
        ? `${memberPrice}`
        : "0",
    url: eventUrl,
    wakeupFiduciaireLogo: fiduciaireLogo,
    eventImage: bannerImgUrl,
    urlEvent: `https://offfcourse.be/${languageKey}/event/${id}/reception`,
    wakeupPlace,
    wakeupReplay,
  };
};
